import skin1 from "./img/skin1.webp";
import Mclaren2025 from "./img/mclaren2025.webp";

const skinsData = [
    {
        img: Mclaren2025,
        name: "Vuse Ultra × McLaren Limited Edition",
        id: "mclaren2025",
    },
    {
        img: skin1,
        name: "Limited Edition - 1 Jahr Inspiration Club",
        id: "birthday2025",
    },
];

export default skinsData;
